export enum CoupaReceiptType {
    QUANTITY = 'ReceivingQuantityConsumption',
    AMOUNT = 'ReceivingAmountConsumption'
}
